import { render } from "./EdicionContratoView.vue?vue&type=template&id=066a46f2"
import script from "./EdicionContratoView.vue?vue&type=script&lang=js"
export * from "./EdicionContratoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__